(function () {
  'use strict';

  const STORAGE_KEY = 'colorcarato_wishlist_v1';

  const defaultData = {
    lists: [
      {
        id: 'default',
        name: 'Wishlist',
        items: []
      }
    ]
  };

  function getData() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);

      if (!saved) {
        return JSON.parse(JSON.stringify(defaultData));
      }

      const data = JSON.parse(saved);

      if (!data.lists || !Array.isArray(data.lists)) {
        return JSON.parse(JSON.stringify(defaultData));
      }

      return data;
    } catch (error) {
      console.error('Wishlist load error:', error);
      return JSON.parse(JSON.stringify(defaultData));
    }
  }
  function removeEmptyWishlistLists(data) {

    if (!data || !Array.isArray(data.lists)) {
      return data;
    }

    const originalLength = data.lists.length;

    data.lists = data.lists.filter(function (list) {

      return (
        list &&
        Array.isArray(list.items) &&
        list.items.length > 0
      );

    });

    /*
      If empty lists were removed,
      save the cleaned data.
    */

    if (data.lists.length !== originalLength) {
      saveData(data);
    }

    return data;
  }
  function saveData(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function getAllItems() {
    const data = getData();
    const map = {};

    data.lists.forEach(function (list) {
      list.items.forEach(function (item) {
        map[item.id] = item;
      });
    });

    return Object.values(map);
  }

  function isProductInWishlist(productId) {
    const data = getData();

    return data.lists.some(function (list) {
      return list.items.some(function (item) {
        return String(item.id) === String(productId);
      });
    });
  }

  function updateCount() {
    const count = getAllItems().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (element) {
      element.textContent = count;

      if (count > 0) {
        element.classList.remove('is-empty');
      } else {
        element.classList.add('is-empty');
      }
    });
  }

  function updateHeartButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      const productId = button.dataset.productId;

      if (isProductInWishlist(productId)) {
        button.classList.add('is-active');
        button.setAttribute('aria-label', 'Remove from wishlist');
        button.setAttribute('aria-pressed', 'true');
      } else {
        button.classList.remove('is-active');
        button.setAttribute('aria-label', 'Add to wishlist');
        button.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function openDrawer(product) {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    const overlay = document.querySelector('[data-wishlist-overlay]');

    if (!drawer) return;

    const image = drawer.querySelector('[data-wishlist-product-image]');
    const title = drawer.querySelector('[data-wishlist-product-title]');
    const price = drawer.querySelector('[data-wishlist-product-price]');

    drawer.dataset.currentProduct = JSON.stringify(product);

    if (image) {
      image.src = product.image || '';
      image.alt = product.title || '';
    }

    if (title) {
      title.textContent = product.title || '';
    }

    if (price) {
      price.textContent = product.price || '';
    }

    renderLists();
    drawer.classList.add('is-active');

    if (overlay) {
      overlay.classList.add('is-active');
    }

    document.body.classList.add('wishlist-drawer-open');
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    const overlay = document.querySelector('[data-wishlist-overlay]');

    if (drawer) {
      drawer.classList.remove('is-active');
    }

    if (overlay) {
      overlay.classList.remove('is-active');
    }

    document.body.classList.remove('wishlist-drawer-open');
  }

  function renderLists() {

    const container = document.querySelector(
      '[data-wishlist-lists]'
    );

    if (!container) return;

    let data = getData();

    /*
      Automatically remove all empty lists
      such as:
  
      Rings (0)
      rings (0)
      Wishlist (0)
    */

    data = removeEmptyWishlistLists(data);

    container.innerHTML = '';

    data.lists.forEach(function (list, index) {

      const label = document.createElement('label');

      label.className = 'cc-wishlist-list__item';

      label.innerHTML = `
      <input
        type="radio"
        name="wishlist-list"
        value="${escapeAttribute(list.id)}"
        ${index === 0 ? 'checked' : ''}
      >

      <span>
        ${escapeHtml(list.name)}
        (${list.items.length})
      </span>
    `;

      container.appendChild(label);

    });

  }

  function addProductToList() {
    const drawer = document.querySelector('[data-wishlist-drawer]');

    if (!drawer) return;

    if (!drawer.dataset.currentProduct) return;

    const product = JSON.parse(drawer.dataset.currentProduct);

    const selected = drawer.querySelector(
      'input[name="wishlist-list"]:checked'
    );

    if (!selected) {
      alert('Please choose a wishlist.');
      return;
    }

    const data = getData();

    const list = data.lists.find(function (item) {
      return item.id === selected.value;
    });

    if (!list) return;

    const exists = list.items.some(function (item) {
      return String(item.id) === String(product.id);
    });

    if (!exists) {
      list.items.push(product);

      // Save immediately
      saveData(data);
    }

    // Update UI immediately
    updateCount();
    updateHeartButtons();

    closeDrawer();

    // Also notify other wishlist components
    document.dispatchEvent(
      new CustomEvent('colorcarato:wishlist:updated')
    );
  }

  function createNewList() {
    const input = document.querySelector('[data-wishlist-new-list-input]');

    if (!input) return;

    const name = input.value.trim();

    if (!name) {
      alert('Please enter a list name.');
      return;
    }

    const data = getData();

    const id =
      'list-' +
      Date.now() +
      '-' +
      Math.random().toString(36).substring(2, 8);

    const drawer = document.querySelector('[data-wishlist-drawer]');

    let currentProduct = null;

    if (drawer && drawer.dataset.currentProduct) {
      try {
        currentProduct = JSON.parse(drawer.dataset.currentProduct);
      } catch (error) {
        console.error(error);
      }
    }

    const newList = {
      id: id,
      name: name,
      items: []
    };

    if (currentProduct) {
      newList.items.push(currentProduct);
    }

    data.lists.push(newList);

    saveData(data);

    input.value = '';

    const newListBox = document.querySelector('[data-wishlist-new-list]');

    if (newListBox) {
      newListBox.classList.remove('is-active');
    }

    renderLists();

    const radio = document.querySelector(
      'input[name="wishlist-list"][value="' + id + '"]'
    );

    if (radio) {
      radio.checked = true;
    }

    updateCount();
    updateHeartButtons();

    closeDrawer();

    document.dispatchEvent(
      new CustomEvent('colorcarato:wishlist:updated')
    );
  }

  function toggleWishlist(product) {
    if (isProductInWishlist(product.id)) {
      removeProduct(product.id);
      return;
    }

    openDrawer(product);
  }

  function removeProduct(productId) {

    const data = getData();

    let removed = false;

    data.lists.forEach(function (list) {

      const oldLength = list.items.length;

      list.items = list.items.filter(function (item) {
        return String(item.id) !== String(productId);
      });

      if (list.items.length !== oldLength) {
        removed = true;
      }

    });

    if (!removed) return;

    // Save first
    saveData(data);

    // Immediately refresh UI
    refreshWishlistUI();
  }

  function deleteList(listId) {
    const data = getData();

    if (data.lists.length <= 1) {
      alert('You need to keep at least one wishlist.');
      return;
    }

    data.lists = data.lists.filter(function (list) {
      return list.id !== listId;
    });

    saveData(data);

    renderWishlistPage();
  }

function renderWishlistPage() {

  const page = document.querySelector(
    '[data-wishlist-page]'
  );

  if (!page) return;


  const loading = page.querySelector(
    '[data-wishlist-loading]'
  );

  const empty = page.querySelector(
    '[data-wishlist-empty]'
  );

  const listsContainer = page.querySelector(
    '[data-wishlist-lists-page]'
  );

  const detailContainer = page.querySelector(
    '[data-wishlist-detail]'
  );


  /*
   * =====================================
   * LOADING STATE
   * =====================================
   */

  if (empty) {
    empty.style.display = 'none';
  }

  if (listsContainer) {
    listsContainer.style.display = 'none';
  }

  if (detailContainer) {
    detailContainer.style.display = 'none';
  }


  /*
   * =====================================
   * GET WISHLIST DATA
   * =====================================
   */

  const data = getData();

  const allItems = [];

  data.lists.forEach(function (list) {

    if (
      list.items &&
      list.items.length
    ) {

      list.items.forEach(function (item) {
        allItems.push(item);
      });

    }

  });


  /*
   * =====================================
   * WAIT FOR LOADING
   * =====================================
   */

  setTimeout(function () {


    /*
     * Remove loading
     */

    if (loading) {
      loading.remove();
    }


    /*
     * =================================
     * EMPTY WISHLIST
     * =================================
     */

    if (allItems.length === 0) {

      if (empty) {
        empty.style.display = '';
      }

      if (listsContainer) {
        listsContainer.innerHTML = '';
        listsContainer.style.display = 'none';
      }

      if (detailContainer) {
        detailContainer.classList.remove(
          'is-active'
        );

        detailContainer.style.display = 'none';
      }

      return;
    }


    /*
     * =================================
     * HAS WISHLIST ITEMS
     * =================================
     */

    if (empty) {
      empty.style.display = 'none';
    }

    if (detailContainer) {
      detailContainer.style.display = '';
    }


    /*
     * Render wishlist lists
     */

    renderWishlistLists(data);


    if (listsContainer) {
      listsContainer.style.display = '';
    }


  }, 1000);

}
  function refreshWishlistUI() {
    const data = getData();

    updateCount();
    updateHeartButtons();

    renderWishlistPage();

    document.dispatchEvent(
      new CustomEvent('colorcarato:wishlist:updated')
    );
  }
  function renderWishlistLists(data) {
    const container = document.querySelector('[data-wishlist-lists-page]');

    if (!container) return;

    container.innerHTML = '';

    data.lists.forEach(function (list) {
      if (!list.items.length) return;

      const card = document.createElement('div');

      card.className = 'cc-wishlist-list-card';

      const images = list.items
        .slice(0, 3)
        .map(function (item) {
          return `
            <img
              src="${escapeAttribute(item.image || '')}"
              alt="${escapeAttribute(item.title || '')}"
              loading="lazy"
            >
          `;
        })
        .join('');

      card.innerHTML = `
        <h2 class="cc-wishlist-list-card__title">
          ${escapeHtml(list.name)}
        </h2>

        <p class="cc-wishlist-list-card__count">
          ${list.items.length} ${list.items.length === 1 ? 'item' : 'items'}
        </p>

        <div class="cc-wishlist-list-card__images">
          ${images}
        </div>

        <button
          type="button"
          class="cc-wishlist-list-card__button"
          data-view-wishlist="${escapeAttribute(list.id)}"
        >
          View Wishlist
        </button>
      `;

      container.appendChild(card);
    });
  }

  async function openWishlistDetail(listId) {
    const data = getData();

    const list = data.lists.find(function (item) {
      return item.id === listId;
    });

    if (!list) return;

    const listsContainer = document.querySelector(
      '[data-wishlist-lists-page]'
    );

    const detail = document.querySelector(
      '[data-wishlist-detail]'
    );

    if (!detail) return;

    if (listsContainer) {
      listsContainer.style.display = 'none';
    }

    detail.classList.add('is-active');
    detail.dataset.currentList = list.id;

    const title = detail.querySelector(
      '[data-wishlist-detail-name]'
    );

    const products = detail.querySelector(
      '[data-wishlist-products]'
    );

    if (title) {
      title.textContent =
        list.name.toUpperCase() +
        ' (' +
        list.items.length +
        ')';
    }

    if (!products) return;

    products.innerHTML = '';

    /*
     * =========================================
     * SWATCH COLOR
     * =========================================
     */

    function getSwatchColor(value) {
      const name = String(value || '')
        .trim()
        .toLowerCase();

      const colors = {
        gold: '#E6C27A',
        'yellow gold': '#E4C36A',
        '18k yellow gold': '#E4C36A',
        '14k yellow gold': '#E4C36A',
        '10k yellow gold': '#E4C36A',

        'rose gold': '#E4B1A1',
        '18k rose gold': '#E4B1A1',
        '14k rose gold': '#E4B1A1',
        '10k rose gold': '#E4B1A1',

        'white gold': '#E4E4E1',
        '18k white gold': '#E4E4E1',
        '14k white gold': '#E4E4E1',
        '10k white gold': '#E4E4E1',

        silver: '#D9DDE0',
        platinum: '#D8D8D8',

        black: '#222222',
        white: '#F5F5F5',
        red: '#C94A4A',
        blue: '#7FA9D8',
        green: '#7FA77A',
        pink: '#E7B3C2',
        purple: '#A58BC2',
        orange: '#D9945B',
        yellow: '#E6D26A',

        diamond: '#E9EEF2',
        pearl: '#F5EEE2',
        opal: '#D9E8E8',
        turquoise: '#70C7C7',
        emerald: '#4F9A70',
        ruby: '#B94A55',
        sapphire: '#5E7FAF',
        amethyst: '#9B79B7'
      };

      if (colors[name]) {
        return colors[name];
      }

      if (name.includes('yellow')) return '#E4C36A';
      if (name.includes('gold')) return '#E4C36A';
      if (name.includes('rose')) return '#E4B1A1';
      if (name.includes('white')) return '#E4E4E1';
      if (name.includes('silver')) return '#D9DDE0';
      if (name.includes('black')) return '#222222';
      if (name.includes('blue')) return '#7FA9D8';
      if (name.includes('green')) return '#7FA77A';
      if (name.includes('pink')) return '#E7B3C2';
      if (name.includes('purple')) return '#A58BC2';
      if (name.includes('red')) return '#C94A4A';
      if (name.includes('opal')) return '#D9E8E8';
      if (name.includes('pearl')) return '#F5EEE2';
      if (name.includes('diamond')) return '#E9EEF2';
      if (name.includes('turquoise')) return '#70C7C7';
      if (name.includes('emerald')) return '#4F9A70';
      if (name.includes('ruby')) return '#B94A55';
      if (name.includes('sapphire')) return '#5E7FAF';
      if (name.includes('amethyst')) return '#9B79B7';

      return '#D9D9D9';
    }


    /*
     * =========================================
     * CREATE SWATCH
     * =========================================
     */

    function createSwatch(value, type, selected, imageUrl) {
      const button = document.createElement('button');

      button.type = 'button';

      button.className =
        'cc-wishlist-swatch-button' +
        (selected ? ' is-selected' : '');

      button.dataset.value = value;
      button.dataset.type = type;

      button.title = value;
      button.setAttribute('aria-label', value);

      const span = document.createElement('span');

      span.className =
        'swatch swatch--solid-color swatch--unscaled';

      span.dataset.swatchName = value;

      /*
      * GEMSTONE
      * If gemstone has an image, use that image.
      */
      if (type.toLowerCase() === 'gemstone' && imageUrl) {
        const img = document.createElement('img');

        img.src = imageUrl;
        img.alt = value;
        img.loading = 'lazy';

        img.style.width = '100%';
        img.style.height = '100%';
        img.style.display = 'block';
        img.style.objectFit = 'cover';
        img.style.objectPosition = 'center';
        img.style.borderRadius = 'inherit';

        span.appendChild(img);
      } else {
        /*
        * COLOR
        * Keep normal color swatch.
        */
        span.style.setProperty(
          '--swatch-background',
          getSwatchColor(value)
        );
      }

      button.appendChild(span);

      return button;
    }


    /*
     * =========================================
     * PRODUCTS
     * =========================================
     */

    for (const item of list.items) {

      const card =
        document.createElement('article');

      card.className = 'cc-wishlist-product-card';

      card.dataset.productId = String(item.id);


      /*
       * SAME CARD STRUCTURE
       */

      card.innerHTML = `
      <div class="cc-wishlist-product-card__image">

        <div class="cc-wishlist-material">
          18k Gold Plated
        </div>
        <a href="${escapeAttribute(item.url || '#')}">

          <img
  class="wishlist-image-first"
  src="${escapeAttribute(item.image || '')}"
  alt="${escapeAttribute(item.title || '')}"
  loading="lazy"
>

<img
  class="wishlist-image-second"
  src="${escapeAttribute(item.image || '')}"
  alt="${escapeAttribute(item.title || '')}"
  loading="lazy"
>
        </a>

        <button
          type="button"
          class="cc-wishlist-product-card__remove"
          data-wishlist-remove="${escapeAttribute(item.id)}"
          aria-label="Remove from wishlist"
        >
          <svg viewBox="0 0 17 17" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 16L16 1"></path>
  <path d="M16 16L1 1"></path>
</svg>
        </button>

      </div>

      <div class="cc-wishlist-product-card__info">

        <p class="cc-wishlist-product-card__title">
          ${escapeHtml(item.title || '')}
        </p>

        <div class="cc-wishlist-product-card__price">
          ${escapeHtml(item.price || '')}
        </div>

        <div
          class="cc-wishlist-variants"
          data-wishlist-variants
        >
          <span>Loading...</span>
        </div>

      <button
  type="button"
  class="cc-wishlist-add-cart"
  data-wishlist-add-cart
  disabled
>
  <span class="add-to-cart-text">
    <span aria-hidden="true" class="svg-wrapper add-to-cart-icon">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="var(--icon-stroke-width)"
          d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"
        ></path>

        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="var(--icon-stroke-width)"
          d="M14.608 12.563v5m2.5-2.5h-5"
        ></path>
      </svg>
    </span>

    <span class="add-to-cart-text__content is-visually-hidden-mobile">
      <span class="add-to-cart-label">Add</span>
    </span>
  </span>

  <span class="add-to-cart__added">
    <span class="svg-wrapper add-to-cart__added-icon">
      <svg
        aria-hidden="true"
        class="checkmark-burst"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="1.5"
        ></circle>

        <path
          d="M9 12.75L11.25 15L15 9.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </span>
  </span>
</button>

      </div>
    `;

      products.appendChild(card);


      /*
       * =========================================
       * PRODUCT HANDLE
       * =========================================
       */

      let handle = item.handle;

      if (!handle && item.url) {

        try {

          const url =
            new URL(
              item.url,
              window.location.origin
            );

          const parts =
            url.pathname
              .split('/')
              .filter(Boolean);

          const productIndex =
            parts.indexOf('products');

          if (productIndex !== -1) {
            handle =
              parts[productIndex + 1];
          }

        } catch (error) { }

      }

      if (!handle) {

        const variantBox =
          card.querySelector(
            '[data-wishlist-variants]'
          );

        if (variantBox) {
          variantBox.innerHTML = '';
        }

        continue;
      }


      try {

        /*
         * =====================================
         * FETCH PRODUCT
         * =====================================
         */

        const response =
          await fetch(
            `/products/${encodeURIComponent(handle)}.js`
          );

        if (!response.ok) {
          throw new Error(
            'Product not found'
          );
        }

        const product =
          await response.json();


        /* =====================================
         * SECOND IMAGE
         * =====================================
         */

        const images = product.images || [];

        const firstImage = card.querySelector(
          '.wishlist-image-first'
        );

        const secondImage = card.querySelector(
          '.wishlist-image-second'
        );

        const imageWrapper = card.querySelector(
          '.cc-wishlist-product-card__image'
        );

        if (
          firstImage &&
          secondImage &&
          imageWrapper &&
          images.length > 1
        ) {
          // FIRST IMAGE
          firstImage.src = images[0];

          // SECOND IMAGE
          secondImage.src = images[1];

          // Make second image ready
          secondImage.style.display = 'block';

          // Hover
          imageWrapper.addEventListener(
            'mouseenter',
            function () {
              firstImage.style.opacity = '0';
              secondImage.style.opacity = '1';
            }
          );

          imageWrapper.addEventListener(
            'mouseleave',
            function () {
              firstImage.style.opacity = '1';
              secondImage.style.opacity = '0';
            }
          );
        } else if (firstImage && secondImage) {
          // Product has only one image
          secondImage.style.display = 'none';
        }


        /*
         * =====================================
         * VARIANTS
         * =====================================
         */

        const variantBox =
          card.querySelector(
            '[data-wishlist-variants]'
          );

        const addButton =
          card.querySelector(
            '[data-wishlist-add-cart]'
          );

        if (
          !variantBox ||
          !addButton
        ) {
          continue;
        }

        const variants =
          product.variants || [];


        /*
         * No variants
         */

        if (!variants.length) {

          variantBox.innerHTML = '';

          addButton.disabled = true;

          continue;
        }


        variantBox.innerHTML = '';


        /*
         * =====================================
         * FIND GEMSTONE OPTION
         * =====================================
         */

        const gemstoneOptionIndex =
          product.options.findIndex(
            function (option) {

              const name =
                option.name
                  .toLowerCase()
                  .trim();

              return (
                name === 'gemstone' ||
                name === 'gem stone'
              );

            }
          );


        /*
         * =====================================
         * FIND COLOR OPTION
         * =====================================
         */

        const colorOptionIndex =
          product.options.findIndex(
            function (option) {

              const name =
                option.name
                  .toLowerCase()
                  .trim();

              return (
                name === 'color' ||
                name === 'colour'
              );

            }
          );


        /*
         * =====================================
         * GEMSTONE HAS PRIORITY
         *
         * If Gemstone exists:
         * DO NOT SHOW COLOR
         * =====================================
         */

        let activeOptionIndex = -1;
        let activeOptionName = '';
        let isGemstone = false;


        if (gemstoneOptionIndex !== -1) {

          activeOptionIndex =
            gemstoneOptionIndex;

          activeOptionName =
            product.options[
              gemstoneOptionIndex
            ].name;

          isGemstone = true;

        } else if (
          colorOptionIndex !== -1
        ) {

          activeOptionIndex =
            colorOptionIndex;

          activeOptionName =
            product.options[
              colorOptionIndex
            ].name;

          isGemstone = false;
        }


        /*
         * =====================================
         * NO COLOR / GEMSTONE
         * =====================================
         */

        if (activeOptionIndex === -1) {

          const firstAvailableVariant =
            variants.find(
              function (variant) {
                return variant.available;
              }
            );

          if (firstAvailableVariant) {

            addButton.disabled = false;

            addButton.dataset.variantId =
              firstAvailableVariant.id;

          }

        } else {

          /*
           * ===================================
           * GET VALUES
           * ===================================
           */

          const values = [];

          variants.forEach(
            function (variant) {

              const value =
                variant.options[
                activeOptionIndex
                ];

              if (
                value &&
                !values.includes(value)
              ) {
                values.push(value);
              }

            }
          );


          /*
           * ===================================
           * WRAPPER
           * ===================================
           */

          const optionWrap =
            document.createElement('div');

          optionWrap.className =
            'cc-wishlist-option-group';

          optionWrap.dataset.optionName =
            activeOptionName;


          /*
           * ===================================
           * GEMSTONE > 4
           * ===================================
           */

          if (
            isGemstone &&
            values.length > 4
          ) {

            /*
             * First 4
             */

            values
              .slice(0, 4)
              .forEach(
                function (value, index) {

                  const swatch =
                    createSwatch(
                      value,
                      activeOptionName,
                      index === 0
                    );

                  optionWrap.appendChild(
                    swatch
                  );

                }
              );


            /*
             * 4+
             */

            const moreButton =
              document.createElement(
                'button'
              );

            moreButton.type =
              'button';

            moreButton.className =
              'cc-wishlist-swatch-more';

            moreButton.textContent =
              '4+';

            moreButton.title =
              'View all gemstones';

            moreButton.setAttribute(
              'aria-label',
              'View all gemstones'
            );


            /*
             * Click 4+
             */

            moreButton.addEventListener(
              'click',
              function () {

                moreButton.remove();


                /*
                 * Remaining gemstones
                 */

                values
                  .slice(4)
                  .forEach(
                    function (value) {

                      const swatch =
                        createSwatch(
                          value,
                          activeOptionName,
                          false
                        );

                      optionWrap.appendChild(
                        swatch
                      );

                      /*
                       * Click new swatch
                       */

                      swatch.addEventListener(
                        'click',
                        function () {

                          optionWrap
                            .querySelectorAll(
                              '.cc-wishlist-swatch-button'
                            )
                            .forEach(
                              function (button) {

                                button.classList.remove(
                                  'is-selected'
                                );

                              }
                            );

                          swatch.classList.add(
                            'is-selected'
                          );

                          updateVariant();

                        }
                      );

                    }
                  );

              }
            );


            optionWrap.appendChild(
              moreButton
            );

          } else {

            /*
             * =================================
             * 4 OR LESS
             * =================================
             */

            values.forEach(
              function (value, index) {

                const swatch =
                  createSwatch(
                    value,
                    activeOptionName,
                    index === 0
                  );

                optionWrap.appendChild(
                  swatch
                );

              }
            );

          }


          variantBox.appendChild(
            optionWrap
          );


          /*
           * ===================================
           * INITIAL SWATCH CLICK
           * ===================================
           */

          optionWrap
            .querySelectorAll(
              '.cc-wishlist-swatch-button'
            )
            .forEach(
              function (button) {

                button.addEventListener(
                  'click',
                  function () {

                    optionWrap
                      .querySelectorAll(
                        '.cc-wishlist-swatch-button'
                      )
                      .forEach(
                        function (item) {

                          item.classList.remove(
                            'is-selected'
                          );

                        }
                      );

                    button.classList.add(
                      'is-selected'
                    );

                    updateVariant();

                  }
                );

              }
            );

        }


        /*
         * =====================================
         * FIND SELECTED VARIANT
         * =====================================
         */

        function getSelectedVariant() {

          /*
           * If no Color/Gemstone
           */

          if (
            activeOptionIndex === -1
          ) {

            return variants.find(
              function (variant) {
                return variant.available;
              }
            );

          }


          const selectedSwatch =
            card.querySelector(
              '.cc-wishlist-swatch-button.is-selected'
            );


          if (!selectedSwatch) {
            return null;
          }


          const selectedValue =
            selectedSwatch.dataset.value;


          return variants.find(
            function (variant) {

              return (
                variant.options[
                activeOptionIndex
                ] === selectedValue &&
                variant.available
              );

            }
          );

        }


        /*
         * =====================================
         * UPDATE VARIANT
         * =====================================
         */

        function updateVariant() {

          const selectedVariant =
            getSelectedVariant();


          if (selectedVariant) {

            addButton.disabled =
              false;

            addButton.dataset.variantId =
              selectedVariant.id;

            setAddCartState(addButton, 'ready');
          } else {

            addButton.disabled =
              true;

            addButton.dataset.variantId =
              '';

            setAddCartState(addButton, 'soldout');

          }

        }


        /*
         * =====================================
         * ADD TO CART
         * =====================================
         */
       /* =====================================
 * ADD TO CART
 * =====================================
 */

function setAddCartState(button, state) {

  if (!button) return;

  const icon = button.querySelector(
    '.add-to-cart-icon'
  );

  const label = button.querySelector(
    '.add-to-cart-label'
  );

  const added = button.querySelector(
    '.add-to-cart__added'
  );


  button.classList.remove(
    'is-adding',
    'is-added',
    'is-soldout'
  );


  /* READY */

  if (state === 'ready') {

    button.disabled = false;

    if (icon) {
      icon.style.display = '';
    }

    if (added) {
      added.style.display = 'none';
    }

    if (label) {
      label.textContent = 'Add';
    }

  }


  /* ADDING */

  else if (state === 'adding') {

    button.disabled = true;

    button.classList.add(
      'is-adding'
    );

    if (icon) {
      icon.style.display = '';
    }

    if (added) {
      added.style.display = 'none';
    }

    if (label) {
      label.textContent = 'Adding...';
    }

  }


  /* ADDED */

  else if (state === 'added') {

    button.disabled = true;

    button.classList.add(
      'is-added'
    );

    if (icon) {
      icon.style.display = 'none';
    }

    if (added) {
      added.style.display = '';
    }

    if (label) {
      label.textContent = 'Added';
    }

  }


  /* SOLD OUT */

  else if (state === 'soldout') {

    button.disabled = true;

    button.classList.add(
      'is-soldout'
    );

    if (icon) {
      icon.style.display = 'none';
    }

    if (added) {
      added.style.display = 'none';
    }

    if (label) {
      label.textContent = 'Sold Out';
    }

  }

}
function openShopifyCartDrawer() {

  /*
   * Try common Shopify cart drawer
   * selectors used by the current theme.
   */

  const drawer = document.querySelector(
    'cart-drawer'
  );

  if (drawer) {

    /*
     * Native/custom drawer methods
     */
    if (
      typeof drawer.open === 'function'
    ) {
      drawer.open();
      return true;
    }

    if (
      typeof drawer.show === 'function'
    ) {
      drawer.show();
      return true;
    }

    /*
     * If drawer uses an active class
     */
    drawer.classList.add('is-open');
    drawer.classList.add('active');

  }


  /*
   * Try cart drawer trigger
   */
  const cartTrigger =
    document.querySelector(
      '[data-cart-drawer-trigger], ' +
      '[data-cart-drawer-toggle], ' +
      '[data-cart-toggle], ' +
      '[aria-controls="cart-drawer"]'
    );


  if (cartTrigger) {

    cartTrigger.click();

    return true;
  }


  /*
   * Try Shopify cart button
   */
  const cartButton =
    document.querySelector(
      'a[href="/cart"], ' +
      'button[href="/cart"], ' +
      '[href="/cart"]'
    );


  if (cartButton) {

    cartButton.click();

    return true;
  }


  return false;
}

/* =====================================
 * ADD PRODUCT
 * =====================================
 */

addButton.addEventListener(
  'click',
  async function (event) {

    event.preventDefault();
    event.stopPropagation();

    const variantId =
      addButton.dataset.variantId;

    if (!variantId) {
      console.error(
        'Wishlist: variant ID missing'
      );
      return;
    }

    if (
      addButton.classList.contains(
        'is-adding'
      )
    ) {
      return;
    }

    setAddCartState(
      addButton,
      'adding'
    );


    try {

      /*
       * =====================================
       * ADD PRODUCT TO SHOPIFY CART
       * =====================================
       */

      const response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body: JSON.stringify({

            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ],

            /*
             * Ask Shopify to return
             * the updated cart drawer.
             */
            sections:
              'cart-drawer-section',

            sections_url:
              window.location.pathname

          })
        }
      );


      const result =
        await response.json();


      /*
       * =====================================
       * CHECK SHOPIFY RESPONSE
       * =====================================
       */

      if (!response.ok) {

        console.error(
          'Shopify Add To Cart Error:',
          result
        );

        throw new Error(
          result.description ||
          result.message ||
          'Unable to add product'
        );
      }


      /*
       * =====================================
       * SUCCESS
       * =====================================
       */

      setAddCartState(
        addButton,
        'added'
      );


      /*
       * =====================================
       * GET CURRENT CART
       * =====================================
       */

      const cartResponse =
        await fetch(
          '/cart.js',
          {
            headers: {
              'Accept':
                'application/json'
            }
          }
        );


      const cart =
        cartResponse.ok
          ? await cartResponse.json()
          : null;


      /*
       * =====================================
       * UPDATE CART COUNT
       * =====================================
       */

      if (cart) {

        const selectors = [
          '[data-cart-count]',
          '.cart-count-bubble',
          '.cart-count',
          '[data-cart-item-count]'
        ];


        document
          .querySelectorAll(
            selectors.join(',')
          )
          .forEach(
            function (element) {

              element.textContent =
                cart.item_count;

            }
          );

      }


      /*
       * =====================================
       * UPDATE CART DRAWER
       * =====================================
       */

      if (
        result.sections &&
        result.sections[
          'cart-drawer-section'
        ]
      ) {

        const parser =
          new DOMParser();


        const doc =
          parser.parseFromString(
            result.sections[
              'cart-drawer-section'
            ],
            'text/html'
          );


        const newDrawer =
          doc.querySelector(
            '#shopify-section-cart-drawer-section'
          );


        const oldDrawer =
          document.querySelector(
            '#shopify-section-cart-drawer-section'
          );


        if (
          newDrawer &&
          oldDrawer
        ) {

         oldDrawer.innerHTML =
         newDrawer.innerHTML;

        }

      }


      /*
       * =====================================
       * NOTIFY SHOPIFY/THEME
       * =====================================
       */

      document.dispatchEvent(
        new CustomEvent(
          'colorcarato:cart:updated',
          {
            detail: {
              cart: cart,
              item: result
            }
          }
        )
      );


      /*
 * =====================================
 * OPEN CART DRAWER
 * =====================================
 */

requestAnimationFrame(function () {

  const cartButton =
    document.querySelector(
      '[data-testid="cart-drawer-trigger"]'
    );

  if (cartButton) {

    cartButton.click();

    return;
  }


  /*
   * Fallback:
   * trigger the Horizon drawer action
   */

  const cartDrawer =
    document.querySelector(
      '#cart-drawer'
    );

  if (cartDrawer) {

    cartDrawer.dispatchEvent(
      new CustomEvent(
        'cart-drawer:open',
        {
          bubbles: true
        }
      )
    );

  }

});


      /*
       * =====================================
       * RESET BUTTON
       * =====================================
       */

      setTimeout(
        function () {

          if (
            document.body.contains(
              addButton
            )
          ) {

            setAddCartState(
              addButton,
              'ready'
            );

          }

        },
        500
      );


    } catch (error) {

      console.error(
        'Wishlist Add To Cart Error:',
        error
      );


      setAddCartState(
        addButton,
        'ready'
      );

    }

  }
);


        /*
         * INITIAL VARIANT
         */

        updateVariant();


      } catch (error) {

        console.error(
          'Wishlist product error:',
          error
        );

        const variantBox =
          card.querySelector(
            '[data-wishlist-variants]'
          );

        if (variantBox) {
          variantBox.innerHTML = '';
        }

      }

    }

  }

  async function refreshShopifyCartUI() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();

      const selectors = [
        '[data-cart-count]',
        '.cart-count-bubble',
        '.cart-count',
        '[data-cart-item-count]'
      ];

      selectors.forEach(function (selector) {
        document
          .querySelectorAll(selector)
          .forEach(function (element) {
            element.textContent = cart.item_count;
          });
      });

      document.dispatchEvent(
        new CustomEvent('colorcarato:cart:updated', {
          detail: {
            cart: cart
          }
        })
      );

    } catch (error) {
      console.error(
        'Unable to refresh Shopify cart UI:',
        error
      );
    }
  }
  function updateCartCountInstantly(change) {

    const selectors = [
      '[data-cart-count]',
      '.cart-count-bubble',
      '.cart-count',
      '[data-cart-item-count]'
    ];

    document
      .querySelectorAll(selectors.join(','))
      .forEach(function (element) {

        const current =
          parseInt(
            element.textContent.replace(/\D/g, ''),
            10
          ) || 0;

        const newCount =
          Math.max(0, current + change);

        element.textContent = newCount;

        if (newCount > 0) {
          element.classList.remove('is-empty');
        } else {
          element.classList.add('is-empty');
        }
      });
  }
  function renderWishlistPage() {

  const page = document.querySelector(
    '[data-wishlist-page]'
  );

  if (!page) return;

  const loading = page.querySelector(
    '[data-wishlist-loading]'
  );

  const empty = page.querySelector(
    '[data-wishlist-empty]'
  );

  const listsContainer = page.querySelector(
    '[data-wishlist-lists-page]'
  );

  const detailContainer = page.querySelector(
    '[data-wishlist-detail]'
  );

  /*
   * Keep empty state hidden
   * while wishlist is loading
   */
  if (empty) {
    empty.style.display = 'none';
  }

  /*
   * Get wishlist data
   */
  const data = getData();

  const allItems = [];

  data.lists.forEach(function (list) {

    if (
      list.items &&
      list.items.length
    ) {

      list.items.forEach(function (item) {
        allItems.push(item);
      });

    }

  });


  /*
   * Loading finished
   */

setTimeout(function () {

  /*
   * Remove loading
   */
  if (loading) {
    loading.remove();
  }


  /*
   * EMPTY WISHLIST
   */
  if (allItems.length === 0) {

    if (empty) {
      empty.style.display = '';
    }

    if (listsContainer) {
      listsContainer.style.display = 'none';
    }

    if (detailContainer) {
      detailContainer.style.display = 'none';
    }

    return;
  }


  /*
   * HAS WISHLIST ITEMS
   */
  if (empty) {
    empty.style.display = 'none';
  }

  if (listsContainer) {
    listsContainer.style.display = '';
  }

  if (detailContainer) {
    detailContainer.style.display = '';
  }

  renderWishlistLists(data);

}, 1000);


  /*
   * EMPTY WISHLIST
   */
  if (allItems.length === 0) {

    if (empty) {
      empty.style.display = '';
    }

    if (listsContainer) {
      listsContainer.innerHTML = '';
      listsContainer.style.display = 'none';
    }

    if (detailContainer) {
      detailContainer.classList.remove(
        'is-active'
      );
    }

    return;
  }


  /*
   * HAS WISHLIST ITEMS
   */
  if (empty) {
    empty.style.display = 'none';
  }

  if (listsContainer) {
    listsContainer.style.display = '';
  }

  renderWishlistLists(data);

}

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function getProductFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      url: button.dataset.productUrl
    };
  }
  function removeFromCurrentList(productId) {

    const data = getData();

    let removed = false;

    data.lists.forEach(function (list) {

      if (!Array.isArray(list.items)) {
        return;
      }

      const oldLength = list.items.length;

      list.items = list.items.filter(function (item) {

        return String(item.id) !== String(productId);

      });

      if (list.items.length !== oldLength) {
        removed = true;
      }

    });

    if (!removed) {
      return;
    }

    /*
     * ==========================================
     * SAVE IMMEDIATELY
     * ==========================================
     */

    saveData(data);


    /*
     * ==========================================
     * REMOVE CARD IMMEDIATELY
     * ==========================================
     */

    document
      .querySelectorAll('.cc-wishlist-product-card')
      .forEach(function (card) {

        if (
          String(card.dataset.productId) ===
          String(productId)
        ) {

          // Instant remove
          card.remove();

        }

      });


    /*
     * ==========================================
     * UPDATE WISHLIST UI IMMEDIATELY
     * ==========================================
     */

    updateCount();

    updateHeartButtons();


    /*
     * ==========================================
     * CHECK CURRENT LIST
     * ==========================================
     */

    const detail =
      document.querySelector(
        '[data-wishlist-detail]'
      );

    if (
      detail &&
      detail.classList.contains('is-active')
    ) {

      const listId =
        detail.dataset.currentList;

      const currentList =
        data.lists.find(function (list) {

          return String(list.id) ===
            String(listId);

        });


      /*
       * Current list empty
       */

      if (
        !currentList ||
        !Array.isArray(currentList.items) ||
        currentList.items.length === 0
      ) {

        detail.classList.remove(
          'is-active'
        );

        detail.innerHTML = '';

        const listsPage =
          document.querySelector(
            '[data-wishlist-lists-page]'
          );

        if (listsPage) {
          listsPage.style.display = '';
        }

      } else {

        /*
         * Update title/count only.
         * Do not rebuild entire page.
         */

        const title =
          detail.querySelector(
            '[data-wishlist-detail-name]'
          );

        if (title) {

          title.textContent =
            currentList.name.toUpperCase() +
            ' (' +
            currentList.items.length +
            ')';

        }

      }

    }


    /*
     * Notify other wishlist components
     */

    document.dispatchEvent(
      new CustomEvent(
        'colorcarato:wishlist:updated'
      )
    );

  }
  document.addEventListener('click', function (event) {
    const wishlistButton = event.target.closest(
      '[data-wishlist-button]'
    );

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();

      const product = getProductFromButton(wishlistButton);

      toggleWishlist(product);

      return;
    }
    if (
      event.target.closest('[data-wishlist-close]') ||
      event.target.closest('[data-wishlist-overlay]')
    ) {
      closeDrawer();
      return;
    }
    if (event.target.closest('[data-wishlist-add]')) {
      event.preventDefault();
      addProductToList();
      return;
    }
    if (event.target.closest('[data-wishlist-create-toggle]')) {
      event.preventDefault();
      const box = document.querySelector('[data-wishlist-new-list]');
      if (box) {
        box.classList.toggle('is-active');
      }
      return;
    }
    if (event.target.closest('[data-wishlist-create]')) {
      event.preventDefault();
      createNewList();
      return;
    }
    const viewButton = event.target.closest(
      '[data-view-wishlist]'
    );
    if (viewButton) {
      openWishlistDetail(viewButton.dataset.viewWishlist);
      return;
    }
    const removeButton = event.target.closest(
      '[data-wishlist-remove]'
    );
    if (removeButton) {
      event.preventDefault();
      removeFromCurrentList(
        removeButton.dataset.wishlistRemove
      );
      return;
    }
    if (event.target.closest('[data-wishlist-back]')) {
      const detail = document.querySelector('[data-wishlist-detail]');
      const listsContainer = document.querySelector(
        '[data-wishlist-lists-page]'
      );
      if (detail) {
        detail.classList.remove('is-active');
      }
      if (listsContainer) {
        listsContainer.style.display = '';
      }
      return;
    }
    if (event.target.closest('[data-wishlist-delete]')) {
      const detail = document.querySelector('[data-wishlist-detail]');
      if (detail && detail.dataset.currentList) {
        deleteList(detail.dataset.currentList);
      }
      return;
    }
    if (event.target.closest('[data-wishlist-header]')) {
      window.location.href = '/pages/wishlist';
    }
  });
document.addEventListener(
  'DOMContentLoaded',
  function () {

    updateCount();

    updateHeartButtons();

    renderWishlistPage();


  }
);
  document.addEventListener(
    'shopify:section:load',
    function () {
      updateCount();
      updateHeartButtons();
      renderWishlistPage();
    }
  );
  document.addEventListener(
    'colorcarato:wishlist:updated',
    function () {
      updateCount();
      updateHeartButtons();
      renderWishlistPage();
    }
  );
  window.ColorCaratoWishlist = {
    getData: getData,
    saveData: saveData,
    getAllItems: getAllItems,
    removeProduct: removeProduct,
    updateCount: updateCount,
    updateHeartButtons: updateHeartButtons
  };
  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      '[data-wishlist-no-list-create]'
    );
    if (!button) return;
    event.preventDefault();
    const noListInput = document.querySelector(
      '[data-wishlist-no-list-input]'
    );
    const existingInput = document.querySelector(
      '[data-wishlist-new-list-input]'
    );
    const existingCreateButton = document.querySelector(
      '[data-wishlist-create]'
    );
    if (!noListInput || !existingInput || !existingCreateButton) {
      return;
    }
    const name = noListInput.value.trim();
    if (!name) {
      alert('Please enter a list name.');
      return;
    }
    existingInput.value = name;
    existingCreateButton.click();
    const addButton = document.querySelector(
      '[data-wishlist-add]'
    );

    if (addButton) {
      addButton.click();
    }
    noListInput.value = '';
  });
})();